import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductSearchService, RoutingService, CurrencyService, LanguageService, ProductSearchPage, ConverterService } from '@spartacus/core';
import { ProductListComponentService, SearchCriteria, ViewConfig } from '@spartacus/storefront';
import { Observable, filter, take, tap } from 'rxjs';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Injectable({
  providedIn: 'root',
})

export class KbProductListComponentServiceService extends ProductListComponentService {
  converterService = inject(ConverterService);
 
  override searchResults$: Observable<ProductSearchPage> = this.productSearchService.getResults().pipe(
    filter((searchResult) => Object.keys(searchResult).length > 0),
    tap((searchResult) => {
      if (searchResult && Array.isArray(searchResult.products)) {
        searchResult = {
          ...searchResult,
          products: searchResult.products.map((product) =>
            this.converterService.convert(product, KB_PRODUCT_URL_NORMALIZER)
          ),
        };
      }
    })
  );
 
  protected override searchIfCriteriaHasChanged(criteria: SearchCriteria) {
    this.productSearchService
      .getResults()
      .pipe(take(1))
      .subscribe((results) => {
        const previous: SearchCriteria = {
          query: results?.currentQuery?.query?.value,
          currentPage: results?.pagination?.currentPage,
          pageSize: results?.pagination?.pageSize,
          sortCode: results?.pagination?.sort,
        };
        this.search(criteria);
      });
  }
}
